import FooterLandingPage from './FooterLandingPage'

export default FooterLandingPage
